module.exports = __webpack_public_path__ + "static/robotImg-7e60c90122cf70ff5b8948e640a23954.png";